module.exports = __webpack_public_path__ + "img/sample.784938c5.png";